import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

/**
 * TradingView free Ticker Tape
 */
const TradingViewTickerTape = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    container.innerHTML = '';

    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    container.appendChild(widgetDiv);

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.type = 'text/javascript';
    script.async = true;
    script.text = JSON.stringify({
      symbols: [
        { proName: 'OANDA:XAUUSD', title: 'GOLD' },
        { proName: 'TVC:DXY', title: 'DXY' },
        { proName: 'TVC:SILVER', title: 'SILVER' },
        { proName: 'FX_IDC:EURUSD', title: 'EURUSD' },
        { proName: 'TVC:US10Y', title: 'US10Y' },
      ],
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: 'adaptive',
      colorTheme: 'dark',
      locale: 'en',
    });
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      className="tradingview-widget-container"
      sx={{ width: '100%', mb: 2, borderRadius: 1, overflow: 'hidden', border: '1px solid #333' }}
    />
  );
};

export default TradingViewTickerTape;
